
import { PunkParsedGameData } from "../../../server/data/PunkParsedGameData";
import { PosterManager, PosterStates } from "../../independent/Poster/PosterManager";
import { SoundManager } from "../../../resource/sound/SoundManager";
import { SoundConfig } from "../../../SoundConfig";
import { PunkGameModuleConfig } from "../../../PunkGameModuleConfig";
import { TrainState } from "../../independent/countup/XWaysCounter";
import { PresentationState, Presentation } from "@nolimitcity/slot-game/bin/core/gamecontroller/presentations/Presentation";
import { SlotGame } from "@nolimitcity/slot-game/bin/core/SlotGame";
import { GameMode } from "@nolimitcity/slot-game/bin/core/gamemode/GameMode";
import { MathHelper } from "@nolimitcity/slot-game/bin/core/utils/MathHelper";

export class TotalWinPresentation extends Presentation {

    protected totalWinAmount:number = 0;

    // #423
    private _winBelowStake: boolean = false;
    protected _state:string = "Post";
    protected currWon:boolean = false;

    public setParsedGamedData(data:PunkParsedGameData):void{
        this.totalWinAmount = data.totalWin;
        this.currWon = data.singleWin > 0;

        // #423
        this._winBelowStake = PunkGameModuleConfig.featurePrice.isWinBelowStake();
        this._state = (!this._winBelowStake && (data.totalWin/data.playedBetValue <= 10)) ? "Post" : "Done";
    }

    public checkForActivation(data:PunkParsedGameData):boolean{ return data.mode != GameMode.NORMAL && data.mode != GameMode.RESPIN && data.nextMode == GameMode.NORMAL};

    protected post():void{
        if(this.currWon) this.pTimeline.to(this,1,{});
        this.pTimeline.add(() => PosterManager.instance.playNoWinPoster(PosterStates.QUEEN2));
        this.pTimeline.to(this,0.800,{});
        this.pTimeline.add(() => PunkGameModuleConfig.featurePrice.reset());
    }

    protected TotalWin():void{
        SlotGame.keypad.setZeroBetSpinCounter(-1);
        PunkGameModuleConfig.xWayCounter.counterActive(true);

        PunkGameModuleConfig.xWayCounter.hardSetValue(Math.pow(3,6));
        this.PresentationState.set(PresentationState.INACTIVE);
        
        this.pTimeline.add(PunkGameModuleConfig.xWayCounter.showGlowPositions([0,1,2,3,4,5],false,0.3));
        this.pTimeline.add(() => PunkGameModuleConfig.xWayCounter.showTrainItems(false,[], 0.3));

        this.pTimeline.add(() => PunkGameModuleConfig.xWayCounter.trainState(TrainState.OPEN_CLOSE,true),this.pTimeline.totalDuration() + 0.15);
        this.pTimeline.add(() => PunkGameModuleConfig.xWayCounter.trainState(TrainState.OUTRO), this.pTimeline.totalDuration() +  MathHelper.frameToSeconds(10));
        this.pTimeline.to(this, TrainState.getDuration(TrainState.OUTRO),{});

        this.pTimeline.add([
            () => PunkGameModuleConfig.xWayCounter.setVisible(true,0.5),
            () => PunkGameModuleConfig.xWayCounter.totalWinMorse(0.5,true),
            () => SoundManager.fadeAmbienceLoop(0,1500)
        ],"-="+0.2);
        
        this.pTimeline.to(this,0.5,{});
        this.pTimeline.add([
            PosterManager.instance.playTotalWin(this.totalWinAmount, this._winBelowStake),
            () => !this._winBelowStake && SoundManager.playSoundEffect(SoundConfig.instance.FS_TOTAL_WIN),  // #423
        ]);
        this.pTimeline.add(() => PunkGameModuleConfig.featurePrice.reset());
    }

    public getPresentation(){

        switch(this._state){
            case "Post":
                this.post();
                this._state = "Done";
                break
            default:
                this.TotalWin();
                break;
        }
    }
}